export default __webpack_public_path__ + "static/media/client16.8d6da3ff.png";